import { json, LoaderFunction } from "@remix-run/node";
import { Outlet, useLoaderData } from "@remix-run/react";

import { Navbar } from "../components/Navbar/Navbar";
import { getArtistsByUserId } from "../models/artist.server";
import { getUserMatchCount } from "../models/match.server";
import { getUser } from "../session.server";

export const loader: LoaderFunction = async ({ request }) => {
  const user = await getUser(request);

  if (!user) {
    return json({ user: null });
  }

  const artists = await getArtistsByUserId(user.id);

  const matchCount = await getUserMatchCount(user.id);

  return json({ user, artists, matchCount });
};

export default function BaseLayout() {
  const { user, matchCount } = useLoaderData<typeof loader>();

  return (
    <>
      <Navbar user={user} matchCount={matchCount} />
      <Outlet />
    </>
  );
}
